// Mobile date picker modal (stacked months + day prices), sharing pricing via kombi.calendarDayPrice.
kombi.calendarMobile = function () {
    const HOTEL_MAX_ADVANCE_DAYS = 540;
    const DEFAULT_PACKAGE_MAX_ADVANCE_DAYS = 365;
    const DEFAULT_PACKAGE_LEAD_DAYS = 5;

    function getPackageLeadDays() {
        var raw = document.body && document.body.dataset
            ? document.body.dataset.packageLeadDays
            : null;
        var parsed = parseInt(raw, 10);
        return (parsed === parsed && parsed >= 0) ? parsed : DEFAULT_PACKAGE_LEAD_DAYS;
    }
    const INITIAL_MONTHS = 2;
    const MONTHS_BATCH = 2;
    const WEEKDAY_LABELS = ["D", "S", "T", "Q", "Q", "S", "S"];
    const MONTH_NAMES_PT = [
        "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
        "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro",
    ];

    const modalEl = document.getElementById("CalendarModal");
    const mountEl = document.getElementById("calendar-mobile-mount");
    const triggerWrap = document.querySelector("#SearchForm .calendar-mobile-trigger");
    const bodyEl = modalEl && modalEl.querySelector(".calendar-mobile__body");

    if (!modalEl || !mountEl || !triggerWrap || typeof flatpickr !== "function") {
        return;
    }

    const displayInput = triggerWrap.querySelector(".calendar-mobile-display");
    const stayStartInput = triggerWrap.querySelector(".dates-0");
    const stayEndInput = triggerWrap.querySelector(".dates-1");
    const fieldClearButton = triggerWrap.querySelector(".clear-calendar");
    const modalClearButton = modalEl.querySelector(".calendar-mobile__clear");
    const advanceButton = modalEl.querySelector(".calendar-mobile__advance");
    const backButton = modalEl.querySelector(".calendar-mobile__back");
    const legendsEl = modalEl.querySelector(".calendar-mobile__legends");
    const ratesNoteEl = modalEl.querySelector(".calendar-mobile__rates-note");

    let fpInstance = null;
    let modalInstance = null;
    let loadedMonths = INITIAL_MONTHS;
    let totalMonths = INITIAL_MONTHS;
    let scrollBeforeSelect = 0;

    function isPackageActive() {
        return kombi.calendarDayPrice ? kombi.calendarDayPrice.isPackageActive() : false;
    }

    function getPackageMinDate() {
        const d = new Date();
        d.setHours(0, 0, 0, 0);
        d.setDate(d.getDate() + getPackageLeadDays() + 1);
        return d;
    }

    function readPackageMaxAdvanceDays() {
        const raw =
            mountEl.getAttribute("data-package-max-advance-days") ||
            triggerWrap.getAttribute("data-package-max-advance-days");
        const parsed = parseInt(raw, 10);
        return Number.isFinite(parsed) && parsed > 0
            ? parsed
            : DEFAULT_PACKAGE_MAX_ADVANCE_DAYS;
    }

    function getMinDate() {
        return isPackageActive() ? getPackageMinDate() : new Date().fp_incr(1);
    }

    function getMaxDate() {
        const days = isPackageActive()
            ? readPackageMaxAdvanceDays()
            : HOTEL_MAX_ADVANCE_DAYS;
        return new Date().fp_incr(days);
    }

    function monthsBetween(start, end) {
        return (
            (end.getFullYear() - start.getFullYear()) * 12 +
            (end.getMonth() - start.getMonth()) +
            1
        );
    }


    function toDateKey(dateObj) {
        return kombi.calendarDayPrice ? kombi.calendarDayPrice.toDateKey(dateObj) : "";
    }

    // "YYYY-MM-DD" via new Date() would parse as UTC and shift a day west of Greenwich.
    function parseLocalDate(value) {
        if (!value) return null;
        const parts = String(value).trim().split("T")[0].split("-");
        if (parts.length !== 3) return null;
        const year = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10);
        const day = parseInt(parts[2], 10);
        if (!year || !month || !day) return null;
        const parsed = new Date(year, month - 1, day);
        return isNaN(parsed.getTime()) ? null : parsed;
    }

    function startOfDay(dateObj) {
        const copy = new Date(dateObj.getTime());
        copy.setHours(0, 0, 0, 0);
        return copy;
    }

    /** Day-granularity range check for the active tab (Hotel and Package differ on both ends). */
    function isSelectableDate(dateObj) {
        if (!dateObj || isNaN(dateObj.getTime())) return false;
        const ts = startOfDay(dateObj).getTime();
        return ts >= getMinDate().getTime() && ts <= getMaxDate().getTime();
    }

    function parseDefaultDates() {
        const parsed = (mountEl.getAttribute("data-default-date") || "")
            .split(",")
            .map(parseLocalDate)
            .filter(Boolean);
        // Half a range would open the calendar on a lone check-in nobody can complete.
        if (!parsed.length || !parsed.every(isSelectableDate)) return null;
        return parsed;
    }

    // YYYY-MM-DD → DD/MM/YY without Date (avoids UTC midnight skew).
    function formatDisplayFromDateKey(dateKey) {
        const parts = String(dateKey).split("T")[0].split("-");
        if (parts.length !== 3 || !parts[0] || !parts[1] || !parts[2]) {
            return "";
        }
        return parts[2] + "/" + parts[1] + "/" + parts[0].slice(-2);
    }

    function hasSelectedDates() {
        if (fpInstance && fpInstance.selectedDates && fpInstance.selectedDates.length > 0) {
            return true;
        }
        const startVal = stayStartInput && stayStartInput.value ? stayStartInput.value.trim() : "";
        const endVal = stayEndInput && stayEndInput.value ? stayEndInput.value.trim() : "";
        return !!(startVal || endVal);
    }

    function isStayComplete() {
        const selected = (fpInstance && fpInstance.selectedDates) || [];
        return selected.length === 2 && selected[0].getTime() < selected[1].getTime();
    }

    /**
     * Muted state for Avançar while the range is incomplete. Never `disabled`: the click
     * has to reach the handler so the validation tooltip can explain what is missing.
     */
    function updateFooterButtonsState() {
        if (modalClearButton) {
            modalClearButton.disabled = !hasSelectedDates();
        }
        if (advanceButton) {
            const complete = isStayComplete();
            advanceButton.classList.toggle("calendar-btn--muted", !complete);
            advanceButton.setAttribute("aria-disabled", complete ? "false" : "true");
            if (complete) kombi.hideValidationTooltip();
        }
    }

    function syncLegendVisibility() {
        const calendar = fpInstance && fpInstance.calendar;
        const hasCalendarData = !!(calendar && Object.keys(calendar).length > 0);
        const showRatesNote = hasCalendarData && !isPackageActive();
        if (legendsEl) {
            legendsEl.classList.toggle("d-none", !hasCalendarData);
            legendsEl.setAttribute("aria-hidden", hasCalendarData ? "false" : "true");
        }
        if (ratesNoteEl) {
            ratesNoteEl.classList.toggle("d-none", !showRatesNote);
            ratesNoteEl.setAttribute("aria-hidden", showRatesNote ? "false" : "true");
        }
    }

    function refreshCalendarUi(instance) {
        if (!instance) return;
        instance.redraw();
        scheduleMonthHeaders(instance);
        syncLegendVisibility();
        updateFooterButtonsState();
    }

    function syncDisplayFromHidden() {
        const startVal = stayStartInput && stayStartInput.value ? stayStartInput.value.trim() : "";
        const endVal = stayEndInput && stayEndInput.value ? stayEndInput.value.trim() : "";
        if (startVal && endVal && displayInput) {
            const start = formatDisplayFromDateKey(startVal);
            const end = formatDisplayFromDateKey(endVal);
            if (start && end) {
                displayInput.value = start + " até " + end;
                if (fieldClearButton) {
                    fieldClearButton.classList.remove("d-none");
                    fieldClearButton.classList.add("d-flex");
                }
                updateFooterButtonsState();
                return;
            }
        }
        if (displayInput) {
            displayInput.value = "";
        }
        if (fieldClearButton) {
            fieldClearButton.classList.add("d-none");
            fieldClearButton.classList.remove("d-flex");
        }
        updateFooterButtonsState();
    }

    function writeHiddenDates(selectedDates) {
        if (stayStartInput) {
            stayStartInput.value = selectedDates[0] ? toDateKey(selectedDates[0]) : "";
        }
        if (stayEndInput) {
            stayEndInput.value = selectedDates[1] ? toDateKey(selectedDates[1]) : "";
        }
    }

    function getDaysWrap(instance) {
        return instance.calendarContainer && instance.calendarContainer.querySelector(".flatpickr-days");
    }

    function buildMonthHeader(monthDate) {
        const block = document.createElement("div");
        block.className = "calendar-mobile__month-block";

        const title = document.createElement("div");
        title.className = "calendar-mobile__month-title mb-3";
        const monthSpan = document.createElement("span");
        monthSpan.className = "calendar-mobile__month-name";
        monthSpan.textContent = MONTH_NAMES_PT[monthDate.getMonth()];
        const yearSpan = document.createElement("span");
        yearSpan.className = "calendar-mobile__month-year";
        yearSpan.textContent = " " + monthDate.getFullYear();
        title.appendChild(monthSpan);
        title.appendChild(yearSpan);

        const weekdays = document.createElement("div");
        weekdays.className = "calendar-mobile__weekdays";
        for (let w = 0; w < WEEKDAY_LABELS.length; w++) {
            const span = document.createElement("span");
            span.className = "calendar-mobile__weekday";
            span.textContent = WEEKDAY_LABELS[w];
            weekdays.appendChild(span);
        }

        block.appendChild(title);
        block.appendChild(weekdays);
        return block;
    }

    function renderMonthHeaders(instance) {
        const daysWrap = getDaysWrap(instance);
        if (!daysWrap) return;

        const children = daysWrap.children;
        for (let i = children.length - 1; i >= 0; i--) {
            if (children[i].classList.contains("calendar-mobile__month-block")) {
                children[i].remove();
            }
        }

        const containers = daysWrap.querySelectorAll(":scope > .dayContainer");
        const baseMonth = instance.currentMonth;
        const baseYear = instance.currentYear;
        for (let index = 0; index < containers.length; index++) {
            const monthDate = new Date(baseYear, baseMonth + index, 1);
            daysWrap.insertBefore(buildMonthHeader(monthDate), containers[index]);
        }
    }

    // Re-inject headers once per Flatpickr build (a build wipes them); microtask runs before paint.
    function scheduleMonthHeaders(instance) {
        if (instance._headerRenderScheduled) return;
        instance._headerRenderScheduled = true;
        Promise.resolve().then(function () {
            instance._headerRenderScheduled = false;
            renderMonthHeaders(instance);
        });
    }

    function resolveHotelPk() {
        // Prefer last fetch from search-bar updateCalendar over static detail-page attrs.
        if (kombi.calendarDayPrice) {
            const lastPk = kombi.calendarDayPrice.getLastHotelPk();
            if (lastPk) {
                return lastPk;
            }
        }
        // After clear, updateCalendar removes these attrs so we do not reuse the page hotel.
        return (
            mountEl.getAttribute("data-initial-hotel") ||
            triggerWrap.getAttribute("data-initial-hotel") ||
            null
        );
    }

    function resolveCalendarUrl() {
        return (
            mountEl.getAttribute("data-calendar-url") ||
            triggerWrap.getAttribute("data-calendar-url") ||
            (kombi.flatpickrInstances[0] && kombi.flatpickrInstances[0].calendar_url) ||
            null
        );
    }

    function setDateOptionIfChanged(instance, key, dateValue) {
        const current = instance.config[key];
        const currentTs = current ? new Date(current).getTime() : null;
        const nextTs = dateValue ? new Date(dateValue).getTime() : null;
        if (currentTs === nextTs) return;
        instance.set(key, dateValue);
    }

    function resetScrollTop() {
        if (bodyEl) bodyEl.scrollTop = 0;
    }

    function restoreBodyScroll(y) {
        if (!bodyEl || y === null || y === undefined) return;
        bodyEl.scrollTop = y;
        requestAnimationFrame(function () {
            bodyEl.scrollTop = y;
            // Month headers re-inject on a microtask after Flatpickr rebuild; pin scroll again.
            Promise.resolve().then(function () {
                bodyEl.scrollTop = y;
            });
        });
    }

    function getFocusDate(instance) {
        const fp = instance || fpInstance;
        if (fp && fp.selectedDates && fp.selectedDates.length) {
            return fp.selectedDates[0];
        }
        const fromInput = parseLocalDate(stayStartInput && stayStartInput.value);
        if (fromInput) return fromInput;
        const defaults = parseDefaultDates();
        return defaults && defaults[0] ? defaults[0] : null;
    }

    function readStay(startValue, endValue) {
        const start = parseLocalDate(startValue);
        const end = parseLocalDate(endValue);
        if (!start || !end || start.getTime() >= end.getTime()) return null;
        return [start, end];
    }

    function forgetParkedStay() {
        if (stayStartInput) delete stayStartInput.dataset.parkedStay;
        if (stayEndInput) delete stayEndInput.dataset.parkedStay;
    }

    /**
     * The hidden inputs are what the form submits, so the stay is reconciled there and not on
     * the Flatpickr selection — the calendar may never have been opened when the tab changes.
     * A stay the active tab cannot show is parked on the input and restored when it fits again.
     */
    function reconcileStayWithTabRange() {
        const stay = readStay(
            stayStartInput && stayStartInput.value,
            stayEndInput && stayEndInput.value
        );
        if (stay) {
            if (stay.every(isSelectableDate)) {
                forgetParkedStay();
                return;
            }
            // Always overwrite: an older parked stay must not outlive a newer one.
            stayStartInput.dataset.parkedStay = stayStartInput.value;
            stayEndInput.dataset.parkedStay = stayEndInput.value;
            writeHiddenDates([]);
            syncDisplayFromHidden();
            return;
        }

        const parked = readStay(
            stayStartInput && stayStartInput.dataset.parkedStay,
            stayEndInput && stayEndInput.dataset.parkedStay
        );
        if (!parked || !parked.every(isSelectableDate)) return;
        stayStartInput.value = stayStartInput.dataset.parkedStay;
        stayEndInput.value = stayEndInput.dataset.parkedStay;
        forgetParkedStay();
        syncDisplayFromHidden();
    }

    // Flatpickr setDate: mirror the reconciled inputs onto the instance before sizing the window.
    function syncSelectionFromInputs(instance) {
        if (!instance) return;
        const stay = readStay(
            stayStartInput && stayStartInput.value,
            stayEndInput && stayEndInput.value
        );
        const selected = instance.selectedDates || [];
        if (!stay) {
            if (selected.length) {
                instance.clear();
                instance.selecting_stay = null;
            }
            return;
        }
        if (
            selected.length === 2 &&
            selected[0].getTime() === stay[0].getTime() &&
            selected[1].getTime() === stay[1].getTime()
        ) {
            return;
        }
        instance.setDate(stay, false);
    }

    function monthsNeededThrough(dateObj) {
        if (!dateObj) return INITIAL_MONTHS;
        // +1 so Flatpickr still shows one month under the selection.
        return Math.max(INITIAL_MONTHS, monthsBetween(getMinDate(), dateObj) + 1);
    }

    // Flatpickr's instance.days is only the first dayContainer — query the whole calendar.
    function findFocusDayElement(instance, focusDate) {
        if (!instance || !instance.calendarContainer || !focusDate) return null;
        const selected = instance.calendarContainer.querySelector(
            ".flatpickr-day.startRange, .flatpickr-day.selected"
        );
        if (selected && selected.dateObj) {
            return selected;
        }
        const year = focusDate.getFullYear();
        const month = focusDate.getMonth();
        const days = instance.calendarContainer.querySelectorAll(".dayContainer .flatpickr-day");
        for (let i = 0; i < days.length; i++) {
            const el = days[i];
            if (
                !el.dateObj ||
                el.classList.contains("prevMonthDay") ||
                el.classList.contains("nextMonthDay")
            ) {
                continue;
            }
            if (el.dateObj.getFullYear() === year && el.dateObj.getMonth() === month) {
                return el;
            }
        }
        return null;
    }

    function scrollBodyToFocusMonth(instance, focusDate) {
        if (!bodyEl || !instance || !focusDate) return false;
        const dayElem = findFocusDayElement(instance, focusDate);
        if (!dayElem) return false;
        const dayContainer = dayElem.closest(".dayContainer");
        const prev = dayContainer && dayContainer.previousElementSibling;
        const target =
            prev && prev.classList.contains("calendar-mobile__month-block")
                ? prev
                : dayContainer || dayElem;
        const bodyRect = bodyEl.getBoundingClientRect();
        const targetRect = target.getBoundingClientRect();
        bodyEl.scrollTop = bodyEl.scrollTop + (targetRect.top - bodyRect.top);
        return true;
    }

    // After Flatpickr rebuild + month-header inject, pin scroll to the selection month.
    function scheduleScrollToFocus(instance, focusDate) {
        if (!focusDate) {
            resetScrollTop();
            return;
        }
        const run = function () {
            if (!scrollBodyToFocusMonth(instance, focusDate)) {
                // Days may not exist yet right after set(showMonths); retry once.
                requestAnimationFrame(function () {
                    scrollBodyToFocusMonth(instance, focusDate);
                });
            }
        };
        Promise.resolve().then(function () {
            requestAnimationFrame(run);
        });
    }

    // jumpToDate(minDate): Flatpickr window always starts at the first bookable month.
    function anchorToFirstMonth(instance) {
        const minDate = getMinDate();
        if (
            instance.currentYear !== minDate.getFullYear() ||
            instance.currentMonth !== minDate.getMonth()
        ) {
            instance.jumpToDate(minDate);
        }
    }

    function syncMonthWindow(instance) {
        const minDate = getMinDate();
        const maxDate = getMaxDate();
        totalMonths = Math.max(2, monthsBetween(minDate, maxDate));
        reconcileStayWithTabRange();
        syncSelectionFromInputs(instance);
        const focusDate = getFocusDate(instance);
        // Flatpickr showMonths grows from minDate through the selected month (earlier months stay).
        loadedMonths = Math.min(totalMonths, monthsNeededThrough(focusDate));
        setDateOptionIfChanged(instance, "minDate", minDate);
        setDateOptionIfChanged(instance, "maxDate", maxDate);
        if (instance.config.showMonths !== loadedMonths) {
            instance.set("showMonths", loadedMonths);
        }
        anchorToFirstMonth(instance);
        scheduleScrollToFocus(instance, focusDate);
        armLoadMore();
    }

    function armLoadMore() {
        const observer = bodyEl && bodyEl._loadMoreIO;
        const sentinel = bodyEl && bodyEl.querySelector(".calendar-mobile__load-sentinel");
        if (!observer || !sentinel) return;
        observer.unobserve(sentinel);
        observer.observe(sentinel);
    }

    function loadMoreMonths() {
        if (!fpInstance || loadedMonths >= totalMonths) return;
        loadedMonths = Math.min(totalMonths, loadedMonths + MONTHS_BATCH);
        const selectingStay = fpInstance.selecting_stay;
        fpInstance.set("showMonths", loadedMonths);
        fpInstance.selecting_stay = selectingStay;
        scheduleMonthHeaders(fpInstance);
        if (loadedMonths < totalMonths) {
            armLoadMore();
        }
    }

    // Bottom sentinel drives incremental month loading (works with or without overflow/selection).
    function setupLoadMore() {
        if (!bodyEl || bodyEl._loadMoreIO) return;
        const sentinel = document.createElement("div");
        sentinel.className = "calendar-mobile__load-sentinel";
        bodyEl.appendChild(sentinel);
        bodyEl._loadMoreIO = new IntersectionObserver(
            function (entries) {
                for (let i = 0; i < entries.length; i++) {
                    if (entries[i].isIntersecting) {
                        loadMoreMonths();
                        break;
                    }
                }
            },
            { root: bodyEl, rootMargin: "240px" }
        );
        bodyEl._loadMoreIO.observe(sentinel);
    }

    function loadCalendarData(instance, options) {
        const hotelPk = resolveHotelPk();
        const calendarUrl = resolveCalendarUrl();
        const scrollToFocus = !!(options && options.scrollToFocus);

        function applyData(data) {
            instance.calendar = data;
            refreshCalendarUi(instance);
            if (scrollToFocus) {
                scheduleScrollToFocus(instance, getFocusDate(instance));
            }
        }

        if (
            kombi.calendarDayPrice &&
            hotelPk &&
            kombi.calendarDayPrice.getLastHotelPk() === hotelPk &&
            kombi.calendarDayPrice.getCachedData()
        ) {
            applyData(kombi.calendarDayPrice.getCachedData());
            return;
        }

        if (hotelPk && calendarUrl && kombi.calendarDayPrice) {
            kombi.calendarDayPrice.fetchCalendar(calendarUrl, hotelPk).then(applyData);
            return;
        }

        applyData(null);
    }

    function createFlatpickr() {
        const minDate = getMinDate();
        const maxDate = getMaxDate();
        totalMonths = Math.max(2, monthsBetween(minDate, maxDate));
        loadedMonths = Math.min(INITIAL_MONTHS, totalMonths);
        const defaultDates = parseDefaultDates();

        fpInstance = flatpickr(mountEl, {
            mode: "range",
            inline: true,
            animate: false,
            disableMobile: true,
            locale: "pt",
            dateFormat: "Y-m-d",
            altInput: false,
            minDate: minDate,
            maxDate: maxDate,
            showMonths: loadedMonths,
            defaultDate: defaultDates,
            monthSelectorType: "static",
            onReady: function (selectedDates, dateStr, instance) {
                instance.calendarContainer.classList.add("calendar-mobile__fp");
                scheduleMonthHeaders(instance);
                updateFooterButtonsState();
            },
            onMonthChange: function (selectedDates, dateStr, instance) {
                scheduleMonthHeaders(instance);
            },
            onChange: function (selectedDates, dateStr, instance) {
                const y = scrollBeforeSelect;
                updateFooterButtonsState();
                // Check-in stays the anchor after the range closes, so the lazy month load
                // rebuilds keep blocking earlier dates and keep the min-stay tip in place.
                instance.selecting_stay = selectedDates.length ? selectedDates[0] : null;
                anchorToFirstMonth(instance);
                instance.redraw();
                scheduleMonthHeaders(instance);
                if (document.activeElement && typeof document.activeElement.blur === "function") {
                    document.activeElement.blur();
                }
                restoreBodyScroll(y);
            },
            onDayCreate: function (dObj, dStr, fp, dayElem) {
                // Flatpickr focuses the picked day; default focus scrolls .calendar-mobile__body.
                if (!dayElem._focusNoScroll) {
                    dayElem._focusNoScroll = true;
                    const nativeFocus = dayElem.focus.bind(dayElem);
                    dayElem.focus = function (opts) {
                        nativeFocus(Object.assign({ preventScroll: true }, opts || {}));
                    };
                }
                kombi.fp_apply_day_rules(fp, dayElem);
                scheduleMonthHeaders(fp);
            },
        });

        fpInstance.calendar = null;
        fpInstance.selecting_stay = null;
        loadCalendarData(fpInstance);
        setupLoadMore();
    }

    function ensureModal() {
        if (!modalInstance) {
            modalInstance = bootstrap.Modal.getOrCreateInstance(modalEl);
        }
        return modalInstance;
    }

    function openMobileCalendar() {
        ensureModal().show();
    }

    function clearSelection(keepOpen) {
        if (!fpInstance) return;
        fpInstance.clear();
        fpInstance.selecting_stay = null;
        forgetParkedStay();
        loadedMonths = Math.min(INITIAL_MONTHS, totalMonths);
        if (fpInstance.config.showMonths !== loadedMonths) {
            fpInstance.set("showMonths", loadedMonths);
        }
        anchorToFirstMonth(fpInstance);
        resetScrollTop();
        writeHiddenDates([]);
        syncDisplayFromHidden();
        updateFooterButtonsState();
        if (keepOpen) {
            fpInstance.redraw();
            scheduleMonthHeaders(fpInstance);
        }
    }

    function showSearchAfterHide() {
        const searchForm = document.getElementById("SearchForm");
        if (!searchForm) return;
        modalEl.addEventListener(
            "hidden.bs.modal",
            function () {
                bootstrap.Modal.getOrCreateInstance(searchForm).show();
            },
            { once: true }
        );
    }

    function advanceSelection(event) {
        if (!fpInstance) return;
        if (!isStayComplete()) {
            // The tooltip is dismissed on the next document click; without this the click
            // that opened it would bubble up and close it immediately.
            if (event) event.stopPropagation();
            kombi.showValidationTooltip(advanceButton, kombi.tooltips.dateRequired);
            return;
        }
        const selected = fpInstance.selectedDates;
        // Confirming a stay makes any parked one obsolete — the latest choice wins.
        forgetParkedStay();
        writeHiddenDates(selected);
        syncDisplayFromHidden();
        showSearchAfterHide();
        ensureModal().hide();
    }

    function bindActions() {
        if (modalClearButton) {
            modalClearButton.addEventListener("click", function () {
                if (modalClearButton.disabled) return;
                clearSelection(true);
            });
        }
        if (advanceButton) {
            advanceButton.addEventListener("click", advanceSelection);
        }
        if (backButton) {
            // data-bs-dismiss hides the calendar; this reopens the search modal, like Avançar.
            backButton.addEventListener("click", showSearchAfterHide);
        }
        if (bodyEl) {
            // Capture before Flatpickr select/focus so we can restore after currentMonth jumps.
            bodyEl.addEventListener(
                "pointerdown",
                function () {
                    scrollBeforeSelect = bodyEl.scrollTop;
                },
                true
            );
        }
        if (fieldClearButton) {
            fieldClearButton.addEventListener("click", function (event) {
                event.preventDefault();
                event.stopPropagation();
                clearSelection(false);
            });
        }
        if (displayInput) {
            displayInput.addEventListener("keydown", function (event) {
                if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    openMobileCalendar();
                }
            });
        }
    }

    function bindModalLifecycle() {
        modalEl.addEventListener("shown.bs.modal", function () {
            if (!fpInstance) {
                createFlatpickr();
            }
            syncMonthWindow(fpInstance);
            loadCalendarData(fpInstance, { scrollToFocus: true });
            syncLegendVisibility();
            updateFooterButtonsState();
            if (kombi.calendarDayPrice) {
                kombi.calendarDayPrice.refreshOnCalendarOpen();
            }
        });

        // The tooltip lives outside the modal, so it would survive the dismiss.
        modalEl.addEventListener("hidden.bs.modal", function () {
            kombi.hideValidationTooltip();
        });
    }

    function bindSearchTabChange() {
        document.addEventListener("searchtab:change", function () {
            syncLegendVisibility();
            // Before the instance guard: the inputs are submitted even when the
            // calendar was never opened on this page load.
            reconcileStayWithTabRange();
            if (!fpInstance) return;

            syncMonthWindow(fpInstance);
            fpInstance.calendar = kombi.calendarDayPrice
                ? kombi.calendarDayPrice.getCachedData()
                : null;
            refreshCalendarUi(fpInstance);
        });
    }

    const previousOpenDatePicker = kombi.openDatePicker;
    kombi.openDatePicker = function () {
        if (window.matchMedia("(min-width: 992px)").matches) {
            if (typeof previousOpenDatePicker === "function") {
                return previousOpenDatePicker.apply(this, arguments);
            }
            return;
        }
        const searchModal = document.getElementById("SearchForm");
        if (searchModal) {
            bootstrap.Modal.getOrCreateInstance(searchModal).show();
        }
        openMobileCalendar();
    };

    kombi.calendarMobile.applyCalendarData = function (data) {
        if (!fpInstance) return;
        fpInstance.calendar = data;
        refreshCalendarUi(fpInstance);
    };

    syncDisplayFromHidden();
    syncLegendVisibility();
    updateFooterButtonsState();
    bindActions();
    bindModalLifecycle();
    bindSearchTabChange();
};
